module.exports = __webpack_public_path__ + "static/sertifika_aqap-394ca9e2394608ebbc32b7ea468b870a.png";